// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export { default } from './PushNotification';
export { PushNotificationPermissionStatus, } from './types';
//# sourceMappingURL=index.js.map